export const gatherCallbacks = (callbacks) => () => callbacks.forEach(f => f.apply([]));
